import React, { useState, useEffect } from "react";

const CourierIntegrationList = () => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const sampleData = [
      { courier: "Bluedart", width: "20", height: "15", length: "30", weight: "2.5", startLocation: "Delhi", endLocation: "Mumbai" },
      { courier: "Ipex", width: "10", height: "12", length: "25", weight: "1.2", startLocation: "Jaipur", endLocation: "Pune" },
    ];
    setRows(sampleData);
  }, []);

  return (
    <div className="scf-list-page">
      <div className="scf-list-card">
        <h2 className="scf-list-title">📦 Courier Integration List</h2>

        <div className="scf-table-wrapper">
          <table className="scf-table">
            <thead>
              <tr>
                <th>Courier</th>
                <th>Width (cm)</th>
                <th>Height (cm)</th>
                <th>Length (cm)</th>
                <th>Weight (kg)</th>
                <th>Start Location</th>
                <th>End Location</th>
              </tr>
            </thead>
            <tbody>
              {rows.length > 0 ? (
                rows.map((row, index) => (
                  <tr key={index}>
                    <td>{row.courier}</td>
                    <td>{row.width}</td>
                    <td>{row.height}</td>
                    <td>{row.length}</td>
                    <td>{row.weight}</td>
                    <td>{row.startLocation}</td>
                    <td>{row.endLocation}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" style={{ textAlign: "center" }}>No data found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <style>{`
        * {
          box-sizing: border-box;
          font-family: Arial, sans-serif;
        }

        .scf-list-page {
          min-height: 100vh;
          width: 80%;
          background: #f4fbff;
          padding: 20px;
        }

        .scf-list-card {
          width: 100%;
          background: #fff;
          padding: 20px;
          border-radius: 16px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.06);
        }

        .scf-list-title {
          text-align: center;
          color: #2fb2e7;
          font-size: 22px;
          margin-bottom: 20px;
        }

        .scf-table-wrapper {
          overflow-x: auto; /* makes table scrollable on mobile */
        }

        .scf-table {
          width: 100%;
          border-collapse: collapse;
          min-width: 800px; /* keep desktop layout */
        }

        .scf-table th,
        .scf-table td {
          padding: 12px;
          font-size: 13px;
          border-bottom: 1px solid #eaeaea;
          text-align: center;
          white-space: nowrap;
        }

        .scf-table th {
          background: #ecf8fd;
          color: #2fb2e7;
          font-weight: 700;
        }

        .scf-table tr:hover {
          background: #f8fcff;
        }

        /* Desktop sidebar spacing */
        @media (min-width: 992px) {
          .scf-list-card {
            margin-left: 260px;
            margin-right: 220px;
          }
        }

        /* Tablet */
        @media (max-width: 1024px) {
          .scf-list-page {
            width: 90%;
            padding: 15px;
          }
        }

        /* Mobile adjustments */
        @media (max-width: 600px) {
          .scf-list-page {
            width: 100%;
            padding: 10px;
          }

          .scf-list-title {
            font-size: 18px;
          }

          .scf-table {
            min-width: 100%; /* allow table to shrink to screen width */
          }

          .scf-table th,
          .scf-table td {
            padding: 8px;
            font-size: 12px;
          }
        }
      `}</style>
    </div>
  );
};

export default CourierIntegrationList;
